import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { getNestedProperty } from 'src/app/shared/utils/object-utils';

@Component({
  selector: 'app-ag-roles-cell-renderer',
  templateUrl: './ag-object-list-cell-renderer.component.html',
  styleUrls: ['./ag-object-list-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AgObjectListCellRendererComponent implements ICellRendererAngularComp {
  params: any;
  objectsType: string;
  propertyName: string;
  objectList: any;
  icon: IconProp;
  // Optional per-item click handler. Omit it and an item is inert, as before.
  itemAction?: (object: any, rowData: any) => void;

  agInit(params: any): void {
    this.objectsType = params.objectType;
    this.propertyName = params.propertyName ?? 'title';
    this.params = params;
    this.objectList = params.data[this.objectsType];
    this.icon = params.icon;
    this.itemAction = params.itemAction;
  }

  refresh(params: any): boolean {
    this.params = params;
    this.objectList = params.data[this.objectsType];
    this.icon = params.icon;
    this.itemAction = params.itemAction;
    return true;
  }

  // `propertyName` may be a dotted path ('company.name'), so the label can come
  // from a nested object and not just a flat key on the list item.
  label(object: any): string {
    return getNestedProperty<string>(object, this.propertyName, '');
  }

  onClick(object: any) {
    this.itemAction?.(object, this.params.data);
  }
}
